import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ToolService } from '../../camtl.service';
import { SystemSelectService } from '../../system-select/system-select.service';
import { RouteValidationService } from "../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'detail',
  templateUrl: './detail.component.html',
  // styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit, OnDestroy {

  constructor(
    private toolCountService: ToolService,
    private systemSelectService: SystemSelectService,
    public routeValidationService: RouteValidationService
  ) { }

  @Input() unassignedToolsCount: number = 0;
  @Input() system: any;


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    var self = this;
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;

        // *Added check so services only get queryied when in Detail Route
        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail')) {
          this.toolCountService.read("/unassigned/count/" + this.system.Id, true)
            .then(function (response) {
              self.unassignedToolsCount = response;
            });
        }
        else {
          self.unassignedToolsCount = 0;
        }

      })
  }
}
